import { withSvgIcon } from './withSvgIcon';

export const NavBarChainsList = withSvgIcon(
  <>
    <path
      d="M17 9L17 7.59611C17 7.21636 16.7849 6.86937 16.4448 6.70047L10.4448 3.72087C10.1646 3.58173 9.83542 3.58173 9.55522 3.72087L3.55523 6.70047C3.2151 6.86937 3 7.21636 3 7.59611V14.382C3 14.7607 3.214 15.107 3.55279 15.2764L9.48094 18.2405C9.80192 18.401 10.1843 18.3772 10.4829 18.1781L11.5 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13 12L20 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13 16L18 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13 20L22 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
